import { api } from '@here/api'

export const handleGetSetupChannels = async () => {
	const { data, error } = await api()
		.from('channel')
		.select(`
      *,
      setup!inner(*),
      message_meta(last_message_at, last_message_id)
    `)
		.eq('setup.status', 'published')

	if (error) throw error

	return (data || [])
		.sort((a, b) => {
			const at = a.message_meta?.last_message_at ?? a.created_at
			const bt = b.message_meta?.last_message_at ?? b.created_at
			return Date.parse(bt) - Date.parse(at) // newest first
		})
		.map((row) => ({
			...row,
			setup: row.setup?.[0] ?? null, // collapse array → single object
		}))
}

// Channels WITHOUT any published setup
export const handleGetGeneralChannels = async () => {
	// Step 1: IDs of channels that DO have a published setup
	const { data: withSetup, error: withSetupErr } = await api()
		.from('channel')
		.select('id')
		.eq('setup.status', 'published')
		.select('id, setup!inner(id)') // force inner join via the embed
	if (withSetupErr) throw withSetupErr

	const blockedIds = (withSetup || []).map((r) => r.id)

	// Step 2: Fetch channels NOT in that id list
	// Handle empty list explicitly to avoid "NOT IN ()" syntax issues
	const query = api().from('channel').select('*, setup(*)')

	const { data, error } =
		blockedIds.length > 0
			? await query.not('id', 'in', `(${blockedIds.map((id) => `"${id}"`).join(',')})`)
			: await query // no published-setup channels exist; take all

	if (error) throw error

	// Normalize shape (these are "general", so no published setup attached)
	return (data || []).map((channel) => ({
		...channel,
		setup: null,
	}))
}

export const handleGetChannelReads = async (userId: string) => {
	const { data } = await api().from('channel_reads').select('*').eq('user_id', userId)

	return data || []
}

export const handleGetMessageMeta = async () => {
	const { data } = await api().from('message_meta').select('*')

	return data || []
}
